import styled from 'styled-components';
import theme from 'theme';
import * as React from 'react';
import t from 'utils/translations';
import QuestionPopover from 'components/common/QuestionPopover';

const { leftNavWidth, sectionPaddingTotal } = theme.componentMeasures;

export const Feeds = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: calc(100vw - ${leftNavWidth} - ${sectionPaddingTotal});

    @media (max-width: 1100px) {
        max-width: calc(100vw - ${sectionPaddingTotal});
    }
`;

export const getTitleElement = (
    title: string,
    popOverText: string
): React.ReactElement => {
    return (
        <>
            <>{title}</> <QuestionPopover content={popOverText} />
        </>
    );
};
